import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {DiscountEntityModel} from "../discount-entity.model";
import {ChangeDetectorRef, Component} from "@angular/core";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {DiscountType} from "../discount.data";
import {Config} from "../../../config";
import {EditMode} from "../../../framework/entity/edit/edit-page/edit-mode";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";
import {Markup_Value_Type, MarkupData} from "../../markup/markup.data";

@Component({
    selector: "wbo-discount-edit-page",
    templateUrl: "./discount-edit-page.component.html",
    providers: [provideEntityModel(DiscountEntityModel)]
})
export class DiscountEditPageComponent extends AbstractEditPage {
    Config = Config;
    EditMode = EditMode;
    DiscountType = DiscountType;

    constructor(public model: DiscountEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService);
    }

    getMarkupNotation(): string {
        const markupValueType: Markup_Value_Type = MarkupData.getValueType(this.model.data.modifier.type);
        return markupValueType == Markup_Value_Type.CURRENCY ? "wbo.common.currencyCode" :
            markupValueType == Markup_Value_Type.PERCENT ? "wbo.common.percent" :
                "wbo.common.empty";
    }
}
